export default {
  'ja': {
    LIST: [
      { text: 'うちで過ごそう', hiragana: 'うちですごそう', roman: 'UCHIDESUGOSOU' },
      { text: '三密を避けよう', hiragana: 'さんみつをさけよう', roman: 'SANNMITUWOSAKEYOU' },
      { text: '医療従事者に感謝しよう', hiragana: 'いりょうじゅうじしゃにかんしゃしよう', roman: 'IRYOUJUUJISHANIKANNSHASIYOU' },
      { text: 'ソーシャルディスタンス', hiragana: 'そーしゃるでぃすたんす', roman: 'SO-SHARUDHISUTANNSU' },
      { text: '密閉空間', hiragana: 'みっぺいくうかん', roman: 'MIPPEIKUUKANN' },
      { text: '密集場所', hiragana: 'みっしゅうばしょ', roman: 'MISSHUUBASHO' },
      { text: '密接場面', hiragana: 'みっせつばめん', roman: 'MISSETUBAMENN' },
      { text: '２週間後の世界を作る', hiragana: 'にしゅうかんごのせかいをつくる', roman: 'NISHUUKANNGONOSEKAIWOTUKURU' },
      { text: '外から帰ったら手を洗おう', hiragana: 'そとからかえったらてをあらおう', roman: 'SOTOKARAKAETTARATEWOARAOU' },
      { text: 'アートにエールを', hiragana: 'あーとにえーるを', roman: 'A-TONIE-RUWO' },
      { text: '買い物は3日に1度に', hiragana: 'かいものはみっかにいちどに', roman: 'KAIMONOHAMIKKANIICHIDONI' },
      { text: '緊急事態宣言', hiragana: 'きんきゅうじたいせんげん', roman: 'KINNKYUUJITAISENNGENN' },
      { text: 'ステイホーム週間', hiragana: 'すていほーむしゅうかん', roman: 'SUTEIHO-MUSHUUKANN' },
      { text: 'サーファー来ないで', hiragana: 'さーふぁーこないで', roman: 'SA-FA-KONAIDE' },
      { text: '接触を8割減らす', hiragana: 'せっしょくをはちわりへらす', roman: 'SESSHOKUWOHACHIWARIHERASU' },
      { text: 'オンライン帰省', hiragana: 'おんらいんきせい', roman: 'ONNRAINNKISEI' },
      { text: '少人数ですいてる時間に', hiragana: 'しょうにんずうですいてるじかんに', roman: 'SHOUNINNZUUDESUITERUJIKANNNI' },
      { text: '待てる買い物は通販で', hiragana: 'まてるかいものはつうはんで', roman: 'MATERUKAIMONOHATUUHANNDE' },
      { text: '飲み会はオンラインで', hiragana: 'のみかいはおんらいんで', roman: 'NOMIKAIHAONNRAINNDE' },
      { text: '診療は遠隔で', hiragana: 'しんりょうはえんかくで', roman: 'SINNRYOUHAENNKAKUDE' },
      { text: '運動は動画を活用', hiragana: 'うんどうはどうがをかつよう', roman: 'UNNDOUHADOUGAWOKATUYOU' },
      { text: '飲食は持ち帰り', hiragana: 'いんしょくはもちかえり', roman: 'INNSHOKUHAMOCHIKAERI' },
      { text: '仕事は在宅勤務', hiragana: 'しごとはざいたくきんむ', roman: 'SIGOTOHAZAITAKUKINNMU' },
      { text: '会話はマスクをつけて', hiragana: 'かいわはますくをつけて', roman: 'KAIWAHAMASUKUWOTUKETE' },
      { text: '史上初インターハイ中止', hiragana: 'しじょうはついんたーはいちゅうし', roman: 'SIJOUHATUINNTA-HAICHUUSI' },
      { text: 'タクシー会社大量解雇', hiragana: 'たくしーがいしゃたいりょうかいこ', roman: 'TAKUSI-GAISHATAIRYOUKAIKO' },
      { text: 'ズーム飲み会', hiragana: 'ずーむのみかい', roman: 'ZU-MUNOMIKAI' },
      { text: 'うちで踊ろう', hiragana: 'うちでおどろう', roman: 'UCHIDEODOROU' },
      { text: '何もしないことが世界を救う', hiragana: 'なにもしないことがせかいをすくう', roman: 'NANIMOSINAIKOTOGASEKAIWOSUKUU' },
      { text: '39度でも軽症', hiragana: 'さんじゅうくどでもけいしょう', roman: 'SANNJUUKUDODEMOKEISHOU' },
      { text: 'レジャーは控えよう', hiragana: 'れじゃーはひかえよう', roman: 'REJA-HAHIKAEYOU' },
      { text: '天才IT大臣オードリータン', hiragana: 'てんさいITだいじんおーどりーたん', roman: 'TENNSAIITDAIJINNO-DORI-TANN' },
      { text: 'アベノマスク', hiragana: 'あべのますく', roman: 'ABENOMASUKU' }
    ]
  },
  'en': {
    LIST: [
      { roman: 'STAY HOME' },
      { roman: 'BE THANKFUL TO ALL THE HEALTH CARE WORKERS' },
      { roman: 'WORK FROM HOME' },
      { roman: 'WORK ONLINE' },
      { roman: 'WEAR A MASK WHEREVER YOU GO' },
      { roman: 'WASH YOUR HANDS WITH SOAP' },
      { roman: 'MAINTAIN SOCIAL DISTANCE' },
      { roman: 'AVOID TOUCHING YOUR EYES' },
      { roman: 'COVER YOUR MOUTH WHEN COUGHING AND SNEEZING' },
      { roman: 'INJECTING DISINFECTANTS IS MEANINGLESS' },
      { roman: 'SAVE THE PLANET BY DOING NOTHING' },
      { roman: 'AVOID LARGE CROWD' },
      { roman: 'TAKE OFF SHOES AT HOME' },
      { roman: 'DO NOT TRAVEL AROUND' },
      { roman: 'SMILE AT HOME FOR YOUR CHILDREN' },
      { roman: 'START SOMETHING NEW FOR A CHANGE' },
      { roman: 'PARTY WITH YOUR FRIENDS ONLINE' },
      { roman: 'THE MOVIE CONTAGION IS HORRIBLY REAL' },
      { roman: 'TOO EARLY TO GIVE OUT IMMUNITY PASSPORT' },
      { roman: 'SOCIAL DISTANCE IS ABOUT SIX FEET' },
      { roman: 'IRONICALLY AIR POLUTION IMPROVED' },
      { roman: 'KILLED BY VIRUS OR KILLED BY ECONOMY' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/common/text.js